import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  validatePassword,
} from '../../../utils/validators';
import messages from '../../../constants/messages';
import Button from '../../shared/Button';
import PasswordInput from '../../shared/PasswordInput';
import styles from './styles.scss'


class PasswordResetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      completed: false,
      errors: {},
      showErrors: false
    };
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onConfirmPasswordChange = this.onConfirmPasswordChange.bind(this);
    this.setError = this.setError.bind(this);
    this.validateConfirmPassword = this.validateConfirmPassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isValid() {
    const { errors } = this.state;
    const values = Object.values(errors).filter(value => value);
    return !values.length;
  }

  handleSubmit(event) {
    event.preventDefault();

    const {
      password,
      showErrors
    } = this.state;

    const {
      onSubmit,
      userId,
      code
    } = this.props;

    // Highlight errors if exist when user submits form
    if (!showErrors) {
      this.setState({ showErrors: true });
    }

    // Prevent submit if errors
    if (!this.isValid) {
      return;
    }

    onSubmit(userId, password, code)
      .then(() => {
        this.setState({
          completed: !this.props.errorMessage,
        });
      });
  }

  onPasswordChange(event) {
    this.setState({
      password: event.target.value,
      confirmPassword: ''
    });
  }

  onConfirmPasswordChange(event) {
    this.setState({
      confirmPassword: event.target.value
    });
  }

  setError(field, error) {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [field]: error
      }
    }));
  }

  validateConfirmPassword(confirmPassword) {
    const { password } = this.state;
    return confirmPassword === password;
  }

  renderErrorMessage() {
    const { errorMessage } = this.props;

    if (!errorMessage) {
      return null;
    }

    return (
      <p className={styles.error}>
        {errorMessage}
      </p>
    );
  }

  renderSuccessMessage() {
    const { completed } = this.state;

    if (!completed) {
      return null;
    }

    return (
      <p className={styles.success}>
        Password has been successfully changed
      </p>
    );
  }

  renderSubmitButton() {
    const { isLoading } = this.props;
    return(
      <Button
        disabled={isLoading}
        kind='primary'
        className='w-100'
      >
        {isLoading ?
          <i className='fa fa-spin fa-spinner' /> :
          'Update password'
        }
      </Button>
    );
  }

  renderForm() {
    const {
      completed,
      password,
      confirmPassword,
      errors,
      showErrors
    } = this.state;

    if (completed) {
      return null;
    }

    return (
      <div>
        <p>Create new password</p>
        <div className='form-group'>
          <PasswordInput
            value={password}
            onChange={this.onPasswordChange}
            onValidate={value => this.setError('password', value)}
            allowBlank={false}
            invalid={(showErrors || password) && !!errors.password}
            error={errors.password}
            validator={validatePassword}
            validationError={messages.validation.password}
            className='mb-3'
          />
          <PasswordInput
            value={confirmPassword}
            onChange={this.onConfirmPasswordChange}
            onValidate={value => this.setError('confirmPassword', value)}
            allowBlank={!password}
            invalid={!!errors.confirmPassword}
            error={errors.confirmPassword}
            validator={this.validateConfirmPassword}
            validationError={messages.validation.confirmPassword}
            placeholder='Confirm password'
          />
        </div>
        {this.renderSubmitButton()}
      </div>
    );
  }

  render() {
    return (
      <form
        className={styles.form}
        onSubmit={this.handleSubmit}
      >
        {this.renderForm()}
        {this.renderErrorMessage()}
        {this.renderSuccessMessage()}
      </form>
    );
  }
}

PasswordResetForm.propTypes = {
  isLoading: PropTypes.bool,
  errorMessage: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  userId: PropTypes.string,
  code: PropTypes.string
};

export default PasswordResetForm;


// WEBPACK FOOTER //
// src/components/login/PasswordResetForm/PasswordResetForm.jsx